module.exports = __webpack_public_path__ + "img/button_suffix_on.e5c76628.svg";